import { create } from "zustand";

interface NavigationState {
  passedParams: string | number | null;
  setPassedParams: (params: string | number | null) => void;
  clearPassedParams: () => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
  passedParams: null,
  setPassedParams: (params) => set({ passedParams: params }),
  clearPassedParams: () => set({ passedParams: null }),
}));
